import { Result } from '@standardnotes/domain-core';
export class ContactBelongsToVault {
    constructor(getVaultUsers) {
        this.getVaultUsers = getVaultUsers;
    }
    async execute(dto) {
        const users = await this.getVaultUsers.execute({
            sharedVaultUuid: dto.vault.sharing.sharedVaultUuid,
            readFromCache: false,
        });
        if (users.isFailed()) {
            return Result.fail('Failed to get vault users');
        }
        return Result.ok(users.getValue().some((u) => u.user_uuid === dto.contact.contactUuid));
    }
}
